import { LoadableLazy } from '@confluence/loadable';

export const RightSidebarLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RightSidebar" */ './RightSidebar')).RightSidebar,
});
